import { createFeatureSelector, createSelector } from '@ngrx/store';
import { selectWindowDetailState } from 'src/app/store/root.selectors';

export const selectWindowWidth = createSelector(
    selectWindowDetailState,
    state => state.documentWidth
)


